import { TransactionItemTypeLetterEnum } from "@repo/core/constants/transactions";
import { TransactionOperationEnum } from "@repo/core/enums/receipts";

export enum TransactionFlowType {
  EMERGENCY_WITHDRAW = "EMERGENCY_WITHDRAW",
  PURCHASE = "PURCHASE",
  FIDELITY_SCORE = "FIDELITY_SCORE",
  BONUS_RETRIEVAL = "BONUS_RETRIEVAL"
}

export interface RouteConfig {
  title: string;
  next?: string;
  previous?: string;
  showConfirmStoreModal?: boolean;
}

export interface FlowConfig {
  type: TransactionFlowType;
  title: string;
  entryPoint: string;
  transactionType: TransactionItemTypeLetterEnum;
  transactionOperation: TransactionOperationEnum;
  routes: Record<string, RouteConfig>;
}
